import { render, staticRenderFns } from "./redRainVerification.vue?vue&type=template&id=0fc0cd29"
import script from "./redRainVerification.vue?vue&type=script&lang=js"
export * from "./redRainVerification.vue?vue&type=script&lang=js"
import style0 from "./redRainVerification.vue?vue&type=style&index=0&id=0fc0cd29&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.25_css-loader@6.11.0_webpack@5.103.0__lodash@4_df383d847b1ecb1982a59b7ba66d6012/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports